/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gem_StoreInputs */

const en_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time Crystal Store`)
};

const ar_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متجر بلورة الزمن`)
};

const de_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time Crystal Store`)
};

const es_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda de cristales de tiempo`)
};

const fr_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La boutique de gemme`)
};

const it_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negozio del Cristallo del Tempo`)
};

const ja_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時の結晶ストア`)
};

const ko_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타임 크리스탈 상점`)
};

const pt_br_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loja de cristais do tempo`)
};

const ru_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кристальный магазин времени`)
};

const th_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ร้านคริสตัลแห่งกาลเวลา`)
};

const tr_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaman Kristali Mağazası`)
};

const zh_cn_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时光宝石商店`)
};

const zh_tw_gem_store = /** @type {(inputs: Gem_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時光寶石商店`)
};

/**
* | output |
* | --- |
* | "Time Crystal Store" |
*
* @param {Gem_StoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const gem_store = /** @type {((inputs?: Gem_StoreInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gem_StoreInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gem_store(inputs)
	if (locale === "ar") return ar_gem_store(inputs)
	if (locale === "de") return de_gem_store(inputs)
	if (locale === "es") return es_gem_store(inputs)
	if (locale === "fr") return fr_gem_store(inputs)
	if (locale === "it") return it_gem_store(inputs)
	if (locale === "ja") return ja_gem_store(inputs)
	if (locale === "ko") return ko_gem_store(inputs)
	if (locale === "pt_br") return pt_br_gem_store(inputs)
	if (locale === "ru") return ru_gem_store(inputs)
	if (locale === "th") return th_gem_store(inputs)
	if (locale === "tr") return tr_gem_store(inputs)
	if (locale === "zh_cn") return zh_cn_gem_store(inputs)
	return zh_tw_gem_store(inputs)
});